import React from 'react';
import contact from '../Images/contact.png'

const ContactMe = () => {
    return (
        <div className='mt-14 mb-10' id='contactme' data-aos="fade-up"
        data-aos-easing="ease-out-cubic"
        data-aos-offset="200"
        data-aos-duration="2000">
            <h1 className='text-3xl text-orange-400 font-bold text-center uppercase mb-10'>Get in Touch | <span className='text-emerald-400'>Send your query</span></h1>

            <div className='grid grid-cols-1 lg:grid-cols-2' >
                <div className=''>
                    <img src={contact} alt="" />
                </div>

                <div className=''>
                    <div class="card flex-shrink-0 w-full max-w-sm shadow-2xl bg-gray-700 transform transition-all hover:scale-105">
                        <div class="card-body">
                            <div class="form-control">
                                <label class="label">
                                    <span class="label-text text-white">Name</span>
                                </label>
                                <input type="text" placeholder="Name" class="input input-bordered" />
                            </div>
                            <div class="form-control">
                                <label class="label">
                                    <span class="label-text text-white">Email</span>
                                </label>
                                <input type="text" placeholder="email" class="input input-bordered" />
                            </div>
                            <div class="form-control">
                                <label class="label">
                                    <span class="label-text text-white">Phone Number</span>
                                </label>
                                <input type="number" placeholder="phone" class="input input-bordered" />
                            </div>
                            <div class="form-control">
                                <label class="label">
                                    <span class="label-text text-white">Your Query</span>
                                </label>
                                <textarea class="textarea textarea-success" placeholder="Type here"></textarea>
                            </div>
                            
                            <div class="form-control mt-6">
                                <button class="btn btn-success text-white">send</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default ContactMe;